// extracted by css-extract-rspack-plugin
export default {"base":"ycog5o_MbMfCLcht","basic":"inQ0WbudEVg8TOoQ","compact":"D0pcZ9HQeLY0u5mz","large":"Z7AvHJNYr46_Fsh8"};